<template>
    <span
      class="status-pill"
      :class="typeClass"
      :style="{'background-color': styleFill, 'color': styleTextColor}"
    >
    <slot name="label">{{ statusLabel }}</slot>
    </span>
</template>

<style scoped>
.status-pill {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
  display: inline-block;
  text-transform: capitalize;
  background-color: var(--kate-background);
  color: var(--kate-type-white);
}

[data-theme="light"] .status-pill {
  background-color: var(--kate-tertiary);
  color: var(--kate-type-white);
}

.status-pill.success {
  background-color: var(--kate-success);
  color: var(--kate-type-dark);
}

.status-pill.warning {
  background-color: var(--kate-warning);
  color: var(--kate-type-dark);
}

.status-pill.warning-alpha {
  background-color: color-mix(in srgb, var(--kate-warning) 12%, transparent);
  color: var(--kate-type-warning);
  border: 1px solid var(--kate-warning);
}

.status-pill.danger {
  background-color: var(--kate-danger);
  color: var(--kate-type-white);
}

.status-pill.primary {
  background-color: var(--kate-primary);
  color: var(--kate-type-dark);
}

.status-pill.neutral {
  background-color: var(--kate-button-outlined-hover);
  color: var(--kate-type-dark);
}

[data-theme="light"] .status-pill.neutral {
  border: 1px solid var(--kate-type-dark);
}

.status-pill.proposed {
  background-color: var(--kate-monitor);
  color: var(--kate-type-dark);
}

[data-theme="light"] .status-pill.proposed {
  background-color: var(--kate-type-warning);
  color: var(--kate-type-dark);
}

.status-pill.empty {
  background-color: transparent;
  color: var(--kate-type-light);
}
</style>

<script>
export default {
  props: {
    statusValue: {
      type: String,
      default: '',
    },
    fill: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      validator: value => !value || ['success', 'warning', 'warning-alpha', 'danger', 'primary', 'neutral', 'proposed', 'empty'].includes(value),
    },
  },
  computed: {
    styleFill() {
      return this.fill || null;
    },

    styleTextColor() {
      return this.textColor || null;
    },

    isEmptyPlaceholder() {
      return this.statusValue === '-'; // K-table empty values are passed as '-' and should render an empty pill
    },

    typeClass() {
      if (this.isEmptyPlaceholder || (!this.$slots.label && !this.statusValue)) {
        return 'empty';
      }
      return this.type || '';
    },

    statusLabel() {
      if (this.$slots.label) {
        return '';
      }
      return this.isEmptyPlaceholder || !this.statusValue ? '-' : this.statusValue.replace(/[_-]/g, ' ');
    },
  },
};
</script>
